<template>
  <div>
    <modal ref="modalLogin" titulo="Accedir com usuari" icono="fa-solid fa-lock" :loading="loading.login" :esCerrable="esCerrable" :hayLanzador="false" @cerrar="cerrarLogin">
      <template v-slot:body>
        <img src="../assets/img/logo.png" alt="Ecostudi" class="d-block mx-auto w-50 mb-3" />
        <form id="form-login" @submit.prevent="login">
          <div class="form-group">
            <label for="login-email">Usuari</label>
            <input type="email" class="form-control" id="login-email" v-model="email" :disabled="loading.login" autocomplete="username" required />
          </div>
          <div class="form-group">
            <label for="login-clave">Clau</label>
            <input type="password" class="form-control" id="login-clave" v-model="clave" :disabled="loading.login" autocomplete="current-password" required />
          </div>
        </form>
      </template>
      <template v-slot:footer>
        <button type="submit" class="btn btn-primary" form="form-login" :disabled="loading.login"><i-submit icono="fa-lock" :loading="loading.login" />Confirmar</button>
      </template>
    </modal>
  </div>
</template>

<script>
export default {
  name: "acceso",
  data() {
    return {
      email: null,
      clave: null,
      loading: {
        login: false,
      },
      esCerrable: false,
    };
  },
  methods: {
    abrirLogin: function () {
      this.$refs.modalLogin.abrir();
    },
    login: function () {
      this.$http.post("api/usuaris", { login: this.email, clave: this.clave }).then((response) => {
        if (response.status == 200) {
          this.$toast.clear();

          this.$emit("login", response.data);
        }
      });
    },
    cerrarLogin: function () {
      this.esCerrable = true;

      this.$nextTick(() => {
        this.$refs.modalLogin.cerrar();

        this.esCerrable = false;
      });
    },
  },
};
</script>